import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { API_URL } from "../../configurations/server-config";

@Injectable({
  providedIn: "root",
})
export class VoyageService {
  constructor(private http: HttpClient) {}

  savevoayge(voyage: any): any {
    return this.http.post(`${API_URL}/voyage`, voyage, {
      observe: "response",
    });
  }

  getAllVoyage(
    page = 0,
    size = 10,
    sortby: any = null,
    orderby: any = null
  ): any {
    return this.http.get(
      `${API_URL}/voyage?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }

  deleteVoyage(id: any): any {
    return this.http.delete(`${API_URL}/voyage?id=${id}`);
  }

  getVoyagelist(): any {
    return this.http.get(`${API_URL}/voyagelist`);
  }

  getVoyagelistFromToday(): any {
    return this.http.get(`${API_URL}/voyagelistfromtoday`);
  }

  getPassagerInVoyage(id: any): any {
    return this.http.get(`${API_URL}/listpassagervoyage?id=${id}`);
  }

  getPassagerInVoyagewithoutcancel(id: any): any {
    return this.http.get(`${API_URL}/listpassagervoyagewithcancel?id=${id}`);
  }

  getPassagerInVoyage2(
    id: any,
    page: any = 0,
    size: any = 10,
    sortby: any = null,
    orderby: any = null
  ): any {
    return this.http.get(
      `${API_URL}/listpassagerinvoyage?id=${id}&page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }
  getAllPassagerVoyage(
    page: any = 0,
    size: any = 10,
    sortby: any = null,
    orderby: any = null
  ): any {
    return this.http.get(
      `${API_URL}/getallpassagervoyage?page=${page}&size=${size}&sortby=${sortby}&direction=${orderby}`
    );
  }
  getvoyageDate(): any {
    return this.http.get(`${API_URL}/getvoyagedate`);
  }

  getAllvoyageDate(): any {
    return this.http.get(`${API_URL}/getallvoyagedate`);
  }

  updatevoaygedetail(voyage: any): any {
    return this.http.post(`${API_URL}/updatevoyagedetail`, voyage, {
      observe: "response",
    });
  }

  updatevoaygeheuredepart(id: any): any {
    return this.http.post(`${API_URL}/updatevoyageheure?id=${id}`, null, {
      observe: "response",
    });
  }

  filterVoyageBydateAndCategory(date: any, cat: any = 0): any {
    return this.http.get(`${API_URL}/voyagelistbydate?dt=${date}&cid=${cat}`);
  }

  updatevoyageReportDetail(voyage: any): any {
    return this.http.post(
      `${API_URL}/updatevoyagereport?id=${voyage.idvoyage}`,
      voyage,
      {
        observe: "response",
      }
    );
  }

  // session management
  getpassagerinsession(session: any): any {
    return this.http.get(`${API_URL}/passagervoyagesession/${session}`);
  }

  getamountticketinsession(session: any): any {
    return this.http.get(`${API_URL}/amountticketsession/${session}`);
  }

  getsessionSummaryDetails(session: any): any {
    return this.http.get(`${API_URL}/sessionsummary?id=${session}`);
  }

  getsellplace(idvoyage: any) {
    return this.http.get(`${API_URL}/sellplace?id=${idvoyage}`);
  }

  getnombrevendu(idvoyage: any) {
    return this.http.get(`${API_URL}/nombrevendu?id=${idvoyage}`);
  }

  updatevoaygePlace(id: any, val: any): any {
    return this.http.post(
      `${API_URL}/updatevoyageplace?id=${id}&pl=${val}`,
      null,
      {
        observe: "response",
      }
    );
  }

  updatevoyagePlace(id: any, val: any): any {
    return this.http.post(
      `${API_URL}/updatevoyageplace2?id=${id}&pl=${val}`,
      null,
      {
        observe: "response",
      }
    );
  }

  // remboursement resource
  getVoyageRemboursement(page: any = 0, size: any = 10, id: any): any {
    return this.http.get(
      `${API_URL}/remboursement?page=${page}&size=${size}&id=${id}`
    );
  }

  getVoyageRemboursementList(id: any): any {
    return this.http.get(`${API_URL}/remboursementlist?id=${id}`);
  }

  validateRemboursement(id: any): any {
    return this.http.post(`${API_URL}/remboursementok?id=${id}`, null);
  }

  updatevoyageStatus(id: any, status: any): any {
    return this.http.post(
      `${API_URL}/updatevoyagestatus?id=${id}&st=${status}`,
      null,
      {
        observe: "response",
      }
    );
  }

  closeAllPreviousVoyage(): any {
    return this.http.post(`${API_URL}/closeallvoyage`, null, {
      observe: "response",
    });
  }

  getVoyageInSession(id: any): any {
    return this.http.get(`${API_URL}/voyagelistinsession?id=${id}`);
  }

  getPassagerInVoyageSession(
    id: any,
    session: any,
    page: any = 0,
    size: any = 10
  ): any {
    return this.http.get(
      `${API_URL}/listpassagervoyageinsession?id=${id}&sid=${session}&page=${page}&size=${size}`
    );
  }

  getpassagerInVoyageList(id: any): any {
    return this.http.get(`${API_URL}/passagerinvoyagelist?id=${id}`);
  }

  searchdestination(
    searchParam: any = null,
    searchParam2: any = null,
    searchParam3: any = null,
    searchParam4: any = null,
    searchParam5: any = null,
    codeVoyage: any = null,
    page: any = 0,
    size: any = 10
  ): any {
    return this.http.post(
      `${API_URL}/voyage/searchdestination?q=${searchParam}&d=${searchParam2}&b=${searchParam3}&s=${searchParam4}&c=${searchParam5}&page=${page}&size=${size}
      &nomvoyage=${codeVoyage}`,
      null
    );
  }

  getVoyageBus(): any {
    return this.http.get(`${API_URL}/voyagebus`);
  }

  getVoyageCode(date: any = null): any {
    if (date != null) {
      return this.http.get(`${API_URL}/getvoyagecode?date=${date}`);
    } else {
      return this.http.get(`${API_URL}/getvoyagecode`);
    }
  }

  // voyage destination service
  getVoyageDestinationByVoyage(id: any): any {
    return this.http.get(`${API_URL}/voyagedestination?id=${id}`);
  }

  updateVoyageDestinationByVoyage(id: any, tarif: any): any {
    return this.http.post(
      `${API_URL}/updatevoyagedestinationtarif?id=${id}&tarif=${tarif}`,
      null
    );
  }
}
